export default __webpack_public_path__ + "static/media/Mirror of Shadow.53b6b01c.jpg";